import { useState } from "react";

import HrmLeaveRequestTableDetail from "../../components/hrm/HrmLeaveRequestTable";
import { ILeaveRequestQuery } from "../../models/Hrm";
import { useGetLeaveRequests } from "../../query/HrmQuery";

export const HrmLeaveRequests = () => {
  const [filter, setFilter] = useState<ILeaveRequestQuery>({
    page: 1,
    limit: 10,
  });

  const { data, isLoading } = useGetLeaveRequests(filter);

  return (
    <>
      <HrmLeaveRequestTableDetail
        data={data!}
        isHasAvatars={true}
        isLoading={isLoading}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};
